export class FeedbackModel {

  constructor(public reason: string,
              public email: string,
              public url: string,
              public ipAddress: string,
              public  rate: string,
              public opinion: string) {

  }

}
